import {Flex, useDisclosure} from '@chakra-ui/react';
import {colors} from 'components/providers';
import {ScrollingMenu, ScrollingMenuCard} from 'components/shared';
import {useTranslation} from 'hooks';
import {FC, useCallback, useState} from 'react';
import {hiddenScrollBarStyles} from 'theme';
import {IPromotionsForProviderResponse} from 'types';

import {PromotionItem, PromotionModal} from './components';

interface IProps {
  promotions?: IPromotionsForProviderResponse[];
  onOpenProductDetailsModal: (productId: number) => void;
}

const default_img = '/provider-promotions/promotion2-icon.png';
const default_bg_img = '/provider-promotions/left-element-for-promotion2.svg';

export const Promotions: FC<IProps> = ({promotions, onOpenProductDetailsModal}) => {
  const {isOpen, onOpen, onClose} = useDisclosure();
  const {t} = useTranslation();
  const [selectedItem, setSelectedItem] = useState<IPromotionsForProviderResponse>();

  const handlePress = useCallback(
    (item: IPromotionsForProviderResponse) => {
      if (item.product_pointer_id) return onOpenProductDetailsModal(item.product_pointer_id);

      if (item.category_pointer_id) {
        const element = document.getElementById(`category-${item.category_pointer_id}`);
        return element?.scrollIntoView({behavior: 'smooth'});
      }
      setSelectedItem(item);
      onOpen();
    },
    [onOpen, onOpenProductDetailsModal],
  );

  if (!promotions?.length) return null;
  return (
    <>
      <ScrollingMenu sx={hiddenScrollBarStyles}>
        {promotions.map((item) => (
          <ScrollingMenuCard itemId={`${item.id}`} key={`${item.id}`}>
            <Flex
              justifyContent="space-between"
              bg={colors.white}
              borderRadius="16px"
              h="120px"
              mt={['5px', '10px']}
              mr={['15px', '35px']}
              w={['320px', '415px']}
              cursor="pointer"
              border="1px solid transparent"
              onClick={() => handlePress(item)}
            >
              <PromotionItem default_img={default_img} default_bg_img={default_bg_img} promotion={item} />
            </Flex>
          </ScrollingMenuCard>
        ))}
      </ScrollingMenu>

      {isOpen && selectedItem && (
        <PromotionModal
          promotion={selectedItem}
          onClose={onClose}
          isOpen={isOpen}
          t={t}
          onOpenProductDetailsModal={onOpenProductDetailsModal}
        />
      )}
    </>
  );
};
